import { DECIMAL_PLACES_DEFAULT } from "@/constants";
import { formatCurrency } from "@/helpers";
import {
  CalculateUnitPricePayloadProps,
  QuotationProductProps,
  QuotationProps,
} from "@/types";
import styles from "./catalog-products.module.css";

export const variants: Record<string, string> = {
  isSelected: styles["button-selected"],
  isUnselected: "",
};

export const generateButtonClasses = (
  isSelected: boolean,
  invalid: boolean
) => {
  return `${invalid && styles.invalid} ${styles.button} ${isSelected ? variants.isSelected : variants.isUnselected}`;
};

export const getValueInMXN = (
  value: number,
  dollarQuotation: number,
  decimalNumber = DECIMAL_PLACES_DEFAULT
) => {
  return formatCurrency(
    value * +dollarQuotation,
    "es-MX",
    "MXN",
    decimalNumber
  );
};

export const checkIfVerifiedSuppliersAreTheSame = (
  values: QuotationProductProps[]
) => {
  if (values.length === 0) return true;

  const firstSupplierUuid =
    values?.[0]?.supplier?.uuid || values?.[0]?.supplierUuid;

  return values.every(
    (saleOrder) =>
      (saleOrder?.supplier?.uuid || saleOrder?.supplierUuid) ===
      firstSupplierUuid
  );
};

export const getQuotationSuggestedUnitPricePayload = ({
  quotationValues,
}: {
  quotationValues: QuotationProps;
}): CalculateUnitPricePayloadProps => {
  return {
    items: quotationValues?.products?.map((product) => ({
      cost: Number(product.cost) || 0,
      price: Number(product.price) || 0,
      quantity: Number(product.quantity) || 0,
      traderCommission: Number(product.traderCommission) || 0,
      cm3:
        Number(product?.catalogProduct?.category?.expectedCm3ProfitRate) || 0,
    })),
    customCost: Number(quotationValues.customsFreightCost || 0),
    firstMileCost: Number(quotationValues.firstMileFreightCost || 0),
    lastMileCost: Number(quotationValues.lastMileFreightCost || 0),
    discount: Number(quotationValues.discount || 0),
    includeIva: quotationValues?.includeIva || false,
    totalFreightPrice: Number(quotationValues?.totalFreightPrice || 0),
    deliveryOption: quotationValues?.deliveryOption || "",
    financingCost: quotationValues?.financingCost
      ? Number(quotationValues.financingCost || 0)
      : undefined,
  };
};
